import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { state } from "app/resources/globals";
import { ResumenCargaDescarga as Comp } from "app/features/componentes/cargas";

export interface Props {
    /**idCargaDescarga */
    idCargaDescargaEAD: number;
}

const ultimoEscaneo = state.map(x => x.ultimaLecturaCargaDescargaEAD);

/**Muestra información resumen de una carga/descawrga */
export class ResumenCargaDescarga extends React.PureComponent<Props> {
    idCargaDescarga = (props: Props) => props.idCargaDescargaEAD;
    resumen = createSelectorRx(this.idCargaDescarga, id => observeResource(resources.CargaDescargaEAD.ObtenerResumen, id));

    render() {
        const resumen = this.resumen(this.props);
        return <Comp idCargaDescarga={this.props.idCargaDescargaEAD} resumen={resumen} ultimoEscaneo={ultimoEscaneo} />
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cargasEAD/edit/estatus/items/resumen.tsx